// extracted by mini-css-extract-plugin
export var configurationSection = "_t7-0";